import { SET_NOTIFICATION } from './types';

export const doSetNotification = (notificationType, show = true) => {
    return {
        type: SET_NOTIFICATION,
        payload: { notificationType, show },
    };
};
